import { parse, stringify } from "qs";

import { formatISODate } from "./dateUtils";

export const buildQueryString = (obj: unknown, isBracketFormat = false): string => {
  return stringify(obj, {
    serializeDate: (date: Date) => formatISODate(date),
    arrayFormat: isBracketFormat ? "brackets" : "comma",
  });
};

const customDecoder = (str, decoder, charset) => {
  const strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }

  if (/^(\d+|\d*\.\d+)$/.test(str)) {
    return parseFloat(str);
  }

  const keywords = {
    true: true,
    false: false,
    null: null,
    undefined,
  };
  if (str in keywords) {
    return keywords[str];
  }

  // utf-8
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

export const parseUrl = (url: string) => {
  return parse(url, {
    ignoreQueryPrefix: true,
    decoder: customDecoder,
  });
};
